import { luaScript } from '../../helpers/helper_store';

const state = {
	treeDataLog: null,
	modalData: null,
	logType: null,
	periodSelected: null,
	serverLogSelected: null,
	visualsMap: null,
	currentTreeNode: null
};

const mutations = {
	changeTreeDataLog: (state, data) => (state.treeDataLog = data),
	setLogType: (state, logType) => (state.logType = logType),
	setModalData: (state, data) => (state.modalData = data),
	setPeriodSelected: (state, PS) => (state.periodSelected = PS),
	setServerLogSelected: (state, server) => (state.serverLogSelected = server),
	setVisualsMap: (state, data) => (state.visualsMap = data),
	setCurrentTreeNode: (state, data) => (state.currentTreeNode = data)
};

const actions = {
	getCommonLog({ commit, rootState, state }, { funcName, params }) {
		return new Promise((resolve, reject) => {
			luaScript('run_parse', funcName, params, rootState.login)
				.then((result) => {
					commit('changeTreeDataLog', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getModalInfo({ commit, rootState, state }, { pid, off_start, off_end }) {
		return new Promise((resolve, reject) => {
			luaScript(
				'run_parse',
				'admin_task_log',
				{
					idServer: state.serverLogSelected,
					month: state.periodSelected,
					pid,
					off_start,
					off_end
				},
				rootState.login
			)
				.then((result) => {
					commit('setModalData', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getVisualsMap({ commit, rootState }) {
		return new Promise((resolve, reject) => {
			luaScript('katemapfull', 'run', null, rootState.login)
				.then((result) => {
					commit('setVisualsMap', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	}
};

const getters = {
	getTreeDataLog: (state) => state.treeDataLog,
	getLogType: (state) => state.logType,
	getModalData: (state) => state.modalData,
	getPeriodSelected: (state) => state.periodSelected,
	getServerLogSelected: (state) => state.serverLogSelected,
	getVisualsMap: (state) => state.visualsMap,
	currentTreeNode: (state) => state.currentTreeNode
};

export default {
	state,
	mutations,
	actions,
	getters
};
